import React from "react";
import PropTypes from "prop-types";
import { Clock, LogOut } from "lucide-react";

import { UIToggle } from "../../../../ui";
import { clx } from "../../../../../utils/Helpers";

const TOGGLE_VARIANTS = {
  lateCheckIn: {
    icon: Clock,
    iconBoxClassName: "event-payroll-auto-deduction-toggle__icon-box--warning",
    iconClassName: "event-payroll-auto-deduction-toggle__icon--warning",
  },
  autoCheckout: {
    icon: LogOut,
    iconBoxClassName: "event-payroll-auto-deduction-toggle__icon-box--destructive",
    iconClassName: "event-payroll-auto-deduction-toggle__icon--destructive",
  },
};

const EventPayrollAutoDeductionToggle = ({
  variant,
  label,
  checked,
  disabled,
  onChange,
}) => {
  const config = TOGGLE_VARIANTS[variant];
  const Icon = config.icon;

  return (
    <div className="event-payroll-auto-deduction-toggle">
      <div className="event-payroll-auto-deduction-toggle__lead">
        <span
          className={clx(
            "event-payroll-auto-deduction-toggle__icon-box",
            config.iconBoxClassName,
          )}
          aria-hidden
        >
          <Icon
            size={12}
            strokeWidth={1.3}
            className={clx(
              "event-payroll-auto-deduction-toggle__icon",
              config.iconClassName,
            )}
          />
        </span>
        <span className="event-payroll-auto-deduction-toggle__label text-body-xs">
          {label}
        </span>
      </div>
      <UIToggle
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        inputProps={{ "aria-label": label }}
        className="event-payroll-auto-deduction-toggle__switch"
      />
    </div>
  );
};

EventPayrollAutoDeductionToggle.propTypes = {
  variant: PropTypes.oneOf(Object.keys(TOGGLE_VARIANTS)).isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

EventPayrollAutoDeductionToggle.defaultProps = {
  disabled: false,
};

export default EventPayrollAutoDeductionToggle;
